import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { MCountUpComponent } from '../../animations/m-count-up/m-count-up.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-count-up-display',
  templateUrl: './m-count-up-display.component.html',
  imports: [NgClass, MCountUpComponent]
})
export class MCountUpDisplayComponent {
  @Input() end!: string;
  @Input() label!: string;
  @Input() textClass!: string;
  @Input() subtitleClass!: string;
  @Input() duration = 2;
}
